import { eventData, eventMapping } from '../../header/header.tracking'
import {
  IHeaderV2ListItem,
  IHeaderV3ListItem,
} from '@/components/Common/HeaderV2/types/types'

export const headerV2InvestList = [
  {
    id: 11,
    title: 'INDstocks',
    relative_path: '',
    list: [
      {
        title: 'Stocks',
        relative_path: '/stocks',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'SIP in Stocks',
        relative_path: '/stocks/category/sip-in-stocks',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Indices',
        relative_path: '/indices',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'IPO',
        relative_path: '/ipo',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Futures & Options',
        relative_path: '/futures-and-options',
        event_data: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerStocksClick],
  },
  {
    id: 12,
    title: 'US Stocks',
    relative_path: '',
    list: [
      {
        title: 'US Stocks',
        relative_path: '/us-stocks',
        eventMapping: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerUsstocksClick],
  },
  {
    id: 13,
    title: 'ETFs',
    relative_path: '',
    list: [
      {
        title: 'Global ETFs',
        relative_path: '/us-stocks/top-etfs',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Gold ETFs',
        relative_path: '/stocks/category/gold-etfs',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'All ETFs',
        relative_path: '/stocks/etf',
        event_data: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerEtfsClick],
  },
  {
    id: 14,
    title: 'Mutual Funds',
    relative_path: '',
    list: [
      {
        title: 'All Mutual Funds',
        relative_path: '/mutual-funds',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Equity Funds',
        relative_path: '/mutual-funds/equity',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Index Funds',
        relative_path: '/mutual-funds/equity/index-funds',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Debt Funds',
        relative_path: '/mutual-funds/debt',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Hybrid Funds',
        relative_path: '/mutual-funds/hybrid',
        event_data: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerMutualfundsClick],
  },
  {
    id: 15,
    title: 'NPS',
    relative_path: '',
    list: [
      {
        title: 'Invest in NPS',
        relative_path: '/features/nps-national-pension-scheme',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'NPS Calculator',
        relative_path: '/calculators/nps-calculator',
        event_data: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerNpsClick],
  },
  {
    id: 16,
    title: 'Other Instruments',
    relative_path: '',
    list: [
      {
        title: 'Fixed Deposits',
        relative_path: '/fixed-deposit',
        event_data: eventMapping[eventData.headerInvestClick],
      },
      {
        title: 'Insurance',
        relative_path: '/insurance',
        event_data: eventMapping[eventData.headerInvestClick],
      },
    ],
    event_data: eventMapping[eventData.headerOtherinstrumentsClick],
  },
]

export const headerV2FeaturesList = [
  {
    id: 17,
    title: 'Calculators',
    relative_path: '',
    event_data: eventMapping[eventData.headerCalculatorClick],
    list: [
      {
        title: 'SIP Calculator',
        relative_path: '/calculators/sip-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Brokerage Calculator',
        relative_path: '/calculators/brokerage-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'SWP Calculator',
        relative_path: '/calculators/swp-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Regular vs Direct MF Calculator',
        relative_path: '/calculators/direct-regular-mutual-funds',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Lumpsum Calculator',
        relative_path: '/calculators/lumpsum-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'GST Calculator',
        relative_path: '/calculators/gst-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'NPS Calculator',
        relative_path: '/calculators/nps-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Post Office RD Calculator',
        relative_path: '/calculators/post-office-rd-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Salary Calculator',
        relative_path: '/calculators/salary-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Gratuity Calculator',
        relative_path: '/calculators/gratuity-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Mutual Fund Returns Calculator',
        relative_path: 'calculators/sip-calculator',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'View all Calculators',
        relative_path: '/calculators',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
    ],
  },
  {
    id: 18,
    title: 'Features',
    relative_path: '',
    event_data: eventMapping[eventData.headerFeaturesClick],
    list: [
      {
        title: 'Trading App',
        relative_path: '/features/best-trading-app',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'INsta Plus',
        relative_path: '/features/insta-plus',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Goals Tracker',
        relative_path: '/features/goals-tracker',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Compare Mutual Funds',
        relative_path: '/mutual-funds/compare',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Track Your Finances',
        relative_path: '/features/track-all-investments',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Switch Regular to Direct MF',
        relative_path: '/features/switch-regular-to-direct-mutual-fund',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Instant Withdrawals',
        relative_path: '/features/instant-withdrawals',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Track Family Mutual Funds',
        relative_path: '/features/track-family-mutual-funds',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Credit Score',
        relative_path: '/check-free-credit-score',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Set Nominee for Mutual Funds',
        relative_path: '/mutual-funds/mutual-fund-nomination',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'Blog',
        relative_path: '/blog',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
      {
        title: 'View all Features',
        relative_path: '/features',
        event_data: eventMapping[eventData.headerFeaturesClick],
      },
    ],
  },
]

export const headerV2MarketList = [
  {
    id: 19,
    title: 'Market Movers',
    relative_path: '',
    event_data: eventMapping[eventData.headerMarketmoversClick],
    list: [
      {
        title: 'Market Today',
        relative_path: '/market',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: '52 Week High',
        relative_path: '/stocks/category/52-week-high',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: '52 Week Low',
        relative_path: '/stocks/category/52-week-low',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Top Gainers',
        relative_path: '/stocks/category/top-gainers',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Top Losers',
        relative_path: '/stocks/category/top-losers',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Only Buyers',
        relative_path: '/stocks/category/only-buyers',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Only Sellers',
        relative_path: '/stocks/category/only-sellers',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
    ],
  },
  {
    id: 20,
    title: 'Stock Category',
    relative_path: '',
    event_data: eventMapping[eventData.headerStockcategoryClick],
    list: [
      {
        title: 'Stocks to buy today',
        relative_path: '/stocks/category/buy-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Penny Stocks',
        relative_path: '/stocks/category/penny-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Multi-bagger Stocks',
        relative_path: '/stocks/category/multibagger-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nifty 50 Stocks',
        relative_path: '/stocks/category/nifty-50-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Large Cap Stocks',
        relative_path: '/stocks/category/large-cap-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Mid Cap Stocks',
        relative_path: '/stocks/category/mid-cap-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Small Cap Stocks',
        relative_path: '/stocks/category/small-cap-stocks',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
    ],
  },
  {
    id: 21,
    title: 'Indices',
    relative_path: '',
    event_data: eventMapping[eventData.headerIndicesClick],
    list: [
      {
        title: 'BSE Sensex',
        relative_path: '/indices/sensex',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nifty 50',
        relative_path: '/indices/nifty-50',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nifty Midcap 100',
        relative_path: '/indices/nifty-midcap-100',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Bank Nifty',
        relative_path: '/indices/bank-nifty',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'FINNIFTY',
        relative_path: '/indices/nifty-financial',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nifty 500',
        relative_path: '/indices/nifty-500',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nifty IT',
        relative_path: '/indices/nifty-it',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
    ],
  },
  {
    id: 22,
    title: 'Global Indices',
    relative_path: '',
    event_data: eventMapping[eventData.headerGlobalindicesClick],
    list: [
      {
        title: 'Gift Nifty',
        relative_path: '/indices/gift-nifty',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Dow Jones Industrial Average',
        relative_path: '/indices/global-indices/dow-jones-industrial-average',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'S&P 500',
        relative_path: '/indices/s-p-500',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Nasdaq 100',
        relative_path: '/indices/global-indices/nasdaq-100',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Russell 2000 Index',
        relative_path: '/indices/russell-2000-index',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'Dow Jones Market',
        relative_path: '/indices/dow-jones-market',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
      {
        title: 'View all Indices',
        relative_path: '/indices',
        event_data: eventMapping[eventData.headerMarketsClick],
      },
    ],
  },
]

export const headerV2DisclosureList = [
  {
    id: 61,
    title: 'Complaint Status',
    relative_path: '/complaints-status',
    event_data: eventMapping[eventData.headerDisclosureClick],
  },
  {
    id: 62,
    title: 'SEBI Investor Charter - Investment Advisor',
    relative_path: '/sebi-investor-charter',
    event_data: eventMapping[eventData.headerDisclosureClick],
  },
  {
    id: 63,
    title: 'More',
    relative_path: '/page/policy-center',
    event_data: eventMapping[eventData.headerDisclosureClick],
  },
]

export const headerV2Config: IHeaderV2ListItem[] = [
  {
    id: 1,
    title: 'Invest',
    relative_path: '',
    list: headerV2InvestList,
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 2,
    title: 'Features',
    relative_path: '',
    list: headerV2FeaturesList,
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 3,
    title: 'Market',
    relative_path: '',
    list: headerV2MarketList,
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 5,
    title: 'Pricing',
    relative_path: '/pricing?type=indian-stocks',
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 6,
    title: 'Disclosure',
    relative_path: '',
    list: headerV2DisclosureList,
    event_data: eventMapping[eventData.headerClick],
  },
]

// const headerV3InvestList1 = {
//   title: null,
//   addClassNames: 'font-medium',
//   list: [
//     {
//       text: 'Indian stocks',
//       img: 'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/INStocks_iso@3x.png',
//       relative_path: '/stocks',
//       alt: 'Invest in Indian stocks online',
//     },
//     {
//       text: 'US stocks',
//       img: 'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/USStocks_iso@3x.png',
//       relative_path: '/us-stocks',
//       alt: 'Buy US stocks from India',
//     },
//     {
//       text: 'Mutual funds',
//       img: 'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/MutualFunds_iso@3x.png',
//       relative_path: '/mutual-funds',
//       alt: 'Invest in mutual funds',
//     },
//     {
//       text: 'F&O',
//       img: 'https://indcdn.indmoney.com//public/images/dashboard_drawer/web_investments_widget_images/cash-iso.png',
//       relative_path: '/futures-and-options',
//       alt: 'Trade in Futures and Options India',
//     },
//     {
//       text: 'IPO',
//       img: 'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/Bonds_iso@3x.png',
//       relative_path: '/ipo',
//       alt: 'Apply for upcoming IPOs in India',
//     },
//     {
//       text: 'NPS',
//       img: 'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/NPS_iso@3x.png',
//       relative_path: '/features/nps-national-pension-scheme',
//       alt: 'Invest in National Pension Scheme online',
//     },
//   ],
// }

// const headerV3InvestList2 = {
//   title: 'Tools',
//   list: [
//     {
//       text: 'SIP Calculator',
//       relative_path: '/calculators/sip-calculator',
//     },
//     {
//       text: 'Brokerage Calculator',
//       relative_path: '/calculators/brokerage-calculator',
//     },
//     {
//       text: 'NPS Calculator',
//       relative_path: '/calculators/nps-calculator',
//     },
//     {
//       text: 'EMI Calculator',
//       relative_path: '/calculators/emi-calculator',
//     },
//     {
//       text: 'FD Calculator',
//       relative_path: '/calculators/fixed-deposit-calculator',
//     },
//     {
//       text: 'All Calculators',
//       relative_path: '/calculators',
//     },
//   ],
// }

// const headerV3DisclosureList1 = {
//   title: null,
//   list: [
//     // {
//     //   text: 'Complaint Status',
//     //   relative_path: '/complaints-status',
//     // },
//     // {
//     //   text: 'Escalation Matrix- Investment Adviser',
//     //   relative_path: '/page/escalation-matrix-investment-adviser',
//     // },
//     // {
//     //   text: 'SEBI Investor Charter - Investment Advisor ',
//     //   relative_path: '/sebi-investor-charter',
//     // },
//     {
//       text: 'More',
//       relative_path: '/page/policy-center',
//     },
//   ],
// }

export const headerV3Config: IHeaderV3ListItem[] = [
  // {
  //   id: 1,
  //   title: 'Invest',
  //   relative_path: '',
  //   list1: headerV3InvestList1,
  //   list2: headerV3InvestList2,
  //   event_data: eventMapping[eventData.headerClick],
  // },
  {
    id: 1,
    title: 'US Stocks',
    relative_path: '/us-stocks',
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 2,
    title: 'Indian Stocks',
    relative_path: '/stocks',
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 3,
    title: 'ETFs',
    relative_path: '/stocks/etf',
    event_data: eventMapping[eventData.headerClick],
  },
  {
    id: 4,
    title: 'Mutual Funds',
    relative_path: '/mutual-funds',
    event_data: eventMapping[eventData.headerClick],
  },

  {
    id: 5,
    title: 'IPO',
    relative_path: '/ipo',
    event_data: eventMapping[eventData.headerClick],
  },

  {
    id: 6,
    title: 'Features',
    relative_path: '/features',
    event_data: eventMapping[eventData.headerClick],
    showHr: true,
  },
  // {
  //   id: 7,
  //   title: 'Blogs',
  //   relative_path: '/blog',
  //   event_data: eventMapping[eventData.headerClick],
  // },
  {
    id: 7,
    title: 'Pricing',
    relative_path: '/pricing',
    event_data: eventMapping[eventData.headerClick],
  },
]
